import { suppliesDiscountIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const deleteSuppliesDiscount = unaryRpc({
  name: "deleteSuppliesDiscount" as const,
  input: z.object({ id: suppliesDiscountIdFormat.schema }),
  output: z.object({}),
});
